(() => {
  if (window.__bbRelatedRecommendationsLoaded) return;
  window.__bbRelatedRecommendationsLoaded = true;

  const ROOT_SELECTOR = '[data-bb-related-recommendations]';

  const recommendationUrl = () => {
    if (window.Maximize && window.Maximize.routes && window.Maximize.routes.productRecommendations) {
      return window.Maximize.routes.productRecommendations;
    }
    return '/recommendations/products';
  };

  const initControls = (root) => {
    const scroller = root.querySelector('[data-bb-related-scroll]');
    if (!scroller || scroller.dataset.bbControlsReady === 'true') return;
    scroller.dataset.bbControlsReady = 'true';

    const getStep = () => {
      const card = scroller.querySelector('.bb-related__card');
      if (!card) return Math.max(scroller.clientWidth * 0.48, 160);
      const track = scroller.querySelector('.bb-related__track');
      const gap = track ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') : 0;
      return card.getBoundingClientRect().width + gap;
    };

    const scrollByCard = (direction) => {
      const rtl = getComputedStyle(scroller).direction === 'rtl';
      const signedDirection = rtl ? -direction : direction;
      scroller.scrollBy({ left: getStep() * signedDirection, behavior: 'smooth' });
    };

    root.querySelector('[data-bb-related-prev]')?.addEventListener('click', () => scrollByCard(-1));
    root.querySelector('[data-bb-related-next]')?.addEventListener('click', () => scrollByCard(1));
  };

  const findMatchingRoot = (doc, blockId) => {
    return Array.from(doc.querySelectorAll(ROOT_SELECTOR)).find(
      (node) => node.dataset.bbRelatedBlockId === blockId
    );
  };

  const loadRoot = async (root) => {
    if (!root || root.dataset.bbRelatedState === 'loading' || root.dataset.bbRelatedState === 'loaded') return;

    if (root.dataset.bbRelatedRendered === 'true') {
      root.dataset.bbRelatedState = 'loaded';
      initControls(root);
      return;
    }

    const sectionId = root.dataset.bbRelatedSectionId;
    const productId = root.dataset.bbRelatedProductId;
    const blockId = root.dataset.bbRelatedBlockId;
    const limit = root.dataset.bbRelatedLimit || '6';

    if (!sectionId || !productId || !blockId) return;

    root.dataset.bbRelatedState = 'loading';

    try {
      const url = `${recommendationUrl()}?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=related`;
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Related recommendations request failed: ${response.status}`);

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const source = findMatchingRoot(doc, blockId);

      if (!source || source.querySelector('[data-bb-related-empty="true"]')) {
        root.hidden = true;
        root.dataset.bbRelatedState = 'loaded';
        return;
      }

      root.innerHTML = source.innerHTML;
      root.dataset.bbRelatedRendered = 'true';
      root.dataset.bbRelatedState = 'loaded';
      root.hidden = false;
      initControls(root);
    } catch (error) {
      root.dataset.bbRelatedState = 'error';
      console.error('[BlazeBuy related recommendations]', error);
    }
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, io) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            io.unobserve(entry.target);
            loadRoot(entry.target);
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 })
    : null;

  const watchRoot = (root) => {
    if (!root || root.dataset.bbRelatedWatched === 'true') return;
    root.dataset.bbRelatedWatched = 'true';

    if (root.dataset.bbRelatedRendered === 'true') {
      root.dataset.bbRelatedState = 'loaded';
      initControls(root);
      return;
    }

    if (observer) observer.observe(root);
    else loadRoot(root);
  };

  const scan = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) watchRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(watchRoot);
  };

  const start = () => {
    scan(document);

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    });

    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target?.closest?.(ROOT_SELECTOR) || event.target?.querySelector?.(ROOT_SELECTOR);
      if (root && root.dataset.bbRelatedState !== 'loaded') loadRoot(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();